
import { Component, Vue } from 'vue-property-decorator'
import { Http } from '@/lib/utils/Http'

@Component({})
export default class LastCustomerRegister extends Vue {
  lastCustomerRegisters: [] = []

  mounted () {
    this.loadLastCustomerRegisters()
    setInterval(this.loadLastCustomerRegisters, 1000)
  }

  async loadLastCustomerRegisters () {
    const res = await Http.request('/api/customer-register/last/10')
    this.lastCustomerRegisters = await res.json()
  }
}
